import { FC } from "react"

export const Loading: FC = () => {
  return <div>Загрузка</div>
}
